import { observer } from 'mobx-react-lite';
import React from 'react';

import type { Event } from '@feathr/blackbox';
import type { IFormSubmitProps } from '@feathr/components';
import { Form, FormSubmit, ImagePicker, Input } from '@feathr/components';

import styles from './EventAddStepOne.css';

interface IProps {
  event: Event;
  onNext: () => void;
}

function BillingConfigurationStepOne({ event, onNext }: IProps) {
  const refs: IFormSubmitProps<Event>['refs'] = {
    name: React.useRef<HTMLInputElement>(null),
  };

  return (
    <Form
      actions={[
        <FormSubmit<Event> key={'next'} model={event} onClick={onNext} refs={refs}>
          Next
        </FormSubmit>,
      ]}
      description={
        'Tell us a bit about your Project. This information is used to help you find this Project later and customize its reports.'
      }
      label={'Create an Project: Project information'}
    >
      <Input
        attribute={'name'}
        helpText={'Name the Project something distinctive and memorable.'}
        label={'Name'}
        model={event}
        ref={refs.name}
        required={true}
        type={'text'}
      />
      <ImagePicker
        attribute={'logo'}
        className={styles.root}
        helpText={
          'Upload an image to represent this Project. This makes it easier to find this Project in your Projects list and customizes the look of its reports.'
        }
        imgClassName={styles.image}
        label={'Project Logo'}
        model={event}
        required={false}
        value={event.get('logo')}
      />
    </Form>
  );
}

export default observer(BillingConfigurationStepOne);
